import { config } from '../../config';

export let redirectToAuth = (
  nextUrl: string,
  i?: {
    intent: 'login' | 'switch';
    userId?: string;
  }
) => {
  let u = new URL(config.authFrontendUrl);
  u.pathname = i?.intent == 'switch' ? '/switch' : '/login';
  u.searchParams.set('redirect_uri', nextUrl);
  if (i?.userId) u.searchParams.set('user_id', i.userId);

  window.location.replace(u.toString());
};

export let redirectToLogout = () => {
  let u = new URL(config.authFrontendUrl);
  u.pathname = '/logout';
  window.location.replace(u.toString());
};
